<template>
  <div class="flex column align-start" id="reminders" v-if="userPendingInvoicesCount > 0">
    <label>Estimado usuario, se le recuerda que tiene {{ textMessage }}.</label>
    <label>Genere sus facturas en el menú de "Facturar Movimientos" o <router-link to="/invoiceable-sales" class="link color-text">click aquí</router-link></label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Reminders',
  computed: {
    ...mapGetters('user', [
      'userHasPendingInvoices',
      'userPendingInvoicesCount'
    ]),
    textMessage () {
      if (this.userPendingInvoicesCount > 1) {
        return `${this.userPendingInvoicesCount} movimientos pendientes  de facturar, solo dispone hasta el final del mes para generar sus facturas`
      }
      return `${this.userPendingInvoicesCount} movimiento pendiente  de facturar, solo dispone hasta el final del mes para generar su factura`
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#reminders {
  border: 1px solid $light-blue;
  padding: 2%;
  background-color: $blue;
}
label, a {
  text-align: start;
  font-weight: bold;
  color: white;
}
</style>
